// 组件对象，大写
import readText from './readText.vue'
export default readText
